import React from "react"
import styled from "styled-components"
import { Styles } from "../../config"

import { Typography } from "../../typo-components"

const Button = styled.button`
	cursor: pointer;
	margin: ${(props) => (props.margin ? props.margin : "0")};
	background: transparent;
	width: ${(props) => (props.width ? props.width : "auto")};
	height: auto;
	text-align: ${(props) => props.textAlign || "center"};
	${(props) => (props.alignSelf ? `align-self: ${props.alignSelf}` : "")};
	padding: ${(props) => (props.padding ? props.padding : "0")};

	transition: all 300ms ease-in-out;
	color: ${(props) => (props.color ? Styles.Color[props.color] : Styles.Color.primary)};

	&:disabled {
		color: ${Styles.Color.lightgray}!important;
		cursor: default;
	}

	&:disabled * {
		color: ${Styles.Color.disabled}!important;
		fill: ${Styles.Color.disabled}!important;
	}

	&:not([disabled]):hover > * {
		color: ${Styles.Color.secondary}!important;
	}
`

const TextButton= (props) => {
	return (
		<Button onDoubleClick={() => false} {...props} type={props.type || "button"}>
			<Typography
				margin={props.innerMargin ? props.innerMargin : "10px"}
				textAlign={props.textAlign || "center"}
				color={props.color}
				variant={props.variant || "t7"}
				width={props.width}
			>
				{props.text}
			</Typography>
		</Button>
	)
}

export default TextButton
